export default '/@lang/services'
